import { render, staticRenderFns } from "./showResults.vue?vue&type=template&id=2be0964d&scoped=true"
import script from "./showResults.vue?vue&type=script&lang=js"
export * from "./showResults.vue?vue&type=script&lang=js"
import style0 from "./showResults.vue?vue&type=style&index=0&id=2be0964d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be0964d",
  null
  
)

export default component.exports